// extracted by mini-css-extract-plugin
export default {"container":"Legend_container__NzbWp"};